<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            @change="$emit('change', $event)"
            :showAdd="showAdd"
            :disabled="disabled"
            :dense="dense"
        />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectOccurrenceStatus',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        filter: {
            type: Array,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        natureId: {

        },
        showNatureRegister: {
            type: Boolean,
            default: false
        }
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },

         natureId(val){
            this.getItems();
        },
    },
    methods: {
        ...mapActions('timeSheet', ['ActionFindOccurrenceStatus']),
        
        async getItems() {

            this.loading = true;
            let payload = {};

            if(this.natureId){
                
                let nature = this.natureId;

                if(this.showNatureRegister){
                    nature += ',1';
                }
                
                payload.find_columns = {
                    occurrence_nature_id: nature
                }
            }

            await this.ActionFindOccurrenceStatus(payload)
                    .then((res) => {
                        
                        if(this.filter){
                            this.items = res.data.filter(i => this.filter.includes(i.id));
                        }else{
                            this.items = res.data;
                        }

                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

    newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
                this.$emit('new-item', item);
            }
        }
    },

    
    
}
</script>